import { API } from '../helpers/fetcher'

export const vippsAuthentication = async params =>
    API.post('v1/transaction/vipps/authenticate', params)